export const selectStyles = (error = false) => ({
    control: (base, state) => ({
        ...base,
        borderRadius: "8px",
        minHeight: "44px",
        borderColor: state.isFocused ? "#364e3d" : error ? "#dc3545" : "#d1d5db",
        boxShadow: state.isFocused ? "0 0 0 1px #364e3d" : "none",
        backgroundColor: state.isDisabled ? "#e9ecef" : "white",
        cursor: state.isDisabled ? "not-allowed" : "default",
        "&:hover": {
            borderColor: state.isFocused ? "#364e3d" : error ? "#dc3545" : "#d1d5db",
        },
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#364e3d" : state.isFocused ? "#edf1ee" : "white",
        color: state.isSelected ? "white" : "black",
        padding: "10px 15px",
        "&:active": {
            backgroundColor: "#364e3d",
            color: "white",
        },
    }),
    menu: (base) => ({
        ...base,
        borderRadius: "8px",
        zIndex: 999,
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    singleValue: (base) => ({
        ...base,
        color: "#495057",
    }),
    placeholder: (base) => ({
        ...base,
        color: "#6c757d",
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "4px 12px",
        minHeight: "42px",
        maxHeight: "90px",
        overflowY: "auto",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "4px",
    }),
    multiValue: (base) => ({
        ...base,
        borderRadius: "6px",
        backgroundColor: "#edf1ee",
        margin: "2px",
        display: "inline-flex",
        alignItems: "center",
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: "#364e3d",
        fontSize: "12px",
        fontWeight: "600",
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: "#364e3d",
        "&:hover": {
            backgroundColor: "#364e3d",
            color: "white",
        },
    }),
    indicatorsContainer: (base) => ({
        ...base,
        minHeight: "42px",
    }),
});

